import { getRoot, Instance, types } from 'mobx-state-tree';
import { PageModel, RootType } from '../../../internal';

export const KvizBlacklistModel = types
  .compose(PageModel, types.model({}))
  .views((self) => ({
    get root(): RootType {
      return getRoot(self);
    },
  }))
  .actions(() => ({
    // eslint-disable-next-line @typescript-eslint/no-empty-function -- data fetching lives in QuizBlacklistSection's useEffect
    async beforePageEnter() {},
  }))
  .named('KvizBlacklistModel');

export type KvizBlacklistModelType = Instance<typeof KvizBlacklistModel>;
